var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Circle2',{attrs:{"size":_vm.size,"background":"#FFF","color":"#1E1E1E","stroke":"3px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }